import { useT } from "@transifex/react";
import { StudentResultAnswerStates } from "../../../helpers/StudentResultModel";

interface StudentResultAnswerStateLabelProps {
    state: StudentResultAnswerStates;
}

/**
 * The verdict as text for screen readers. Sighted users read it from the answer's colouring and the
 * check, which say nothing to assistive technology — so every state gets a label here, not only the
 * correct one.
 */
const StudentResultAnswerStateLabel = (props: StudentResultAnswerStateLabelProps) => {
    const t = useT();
    const t_sr_correct = t("Correct", { _tags: "StudentResult, AnswerStateLabel, ScreenReaderOnly" });
    const t_sr_partiallyCorrect = t("Partially correct", {
        _tags: "StudentResult, AnswerStateLabel, ScreenReaderOnly",
    });
    const t_sr_incorrect = t("Incorrect", { _tags: "StudentResult, AnswerStateLabel, ScreenReaderOnly" });
    const t_sr_noAnswer = t("No answer", { _tags: "StudentResult, AnswerStateLabel, ScreenReaderOnly" });

    const labelByState: Record<StudentResultAnswerStates, string> = {
        [StudentResultAnswerStates.CORRECT]: t_sr_correct,
        [StudentResultAnswerStates.PARTIALLY_CORRECT]: t_sr_partiallyCorrect,
        [StudentResultAnswerStates.INCORRECT]: t_sr_incorrect,
        [StudentResultAnswerStates.NO_ANSWER]: t_sr_noAnswer,
    };

    return <span className="sr-only">{labelByState[props.state]}</span>;
};

export default StudentResultAnswerStateLabel;
